import { getCoreAssetType } from '../../../../state/configuration'
import { CheckoutConfigContext } from './types'

export const always = () => true

export const isNotAuthenticated = ({ principal }: CheckoutConfigContext) =>
  !principal.isAuthenticated

export const hasFinalMile = ({ product }: CheckoutConfigContext) =>
  Boolean(product.checkout?.finalMile?.length ?? false)

export const hasAddons = ({ product }: CheckoutConfigContext) => {
  const coreAssetType = getCoreAssetType(product)
  return coreAssetType.covers.optional?.some((it) => !it.form) ?? false
}
